import { useForm } from "react-hook-form";
import { ScaleLoader } from "react-spinners";

const INPUT_BASE =
  "w-full h-[44px] px-3 bg-[#F6F6F8] border rounded-[8px] text-[15px] text-gray-800 outline-none transition-colors duration-200 placeholder-gray-400";
const INPUT_OK =
  "border-[#DADADF] focus:border-brand-purple focus:shadow-[0_0_0_3px_rgba(123,94,167,0.12)]";
const INPUT_ERR = "border-[#E05252]";

const ResetPassword = ({ onSubmit, loading }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <>
      <div className="mb-5">
        <h2 className="text-[20px] font-bold text-navy mb-1">Forgot your password?</h2>
        <p className="text-xs text-gray-400">
          Enter your email and we'll send you a reset code.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="mb-5">
          <label
            htmlFor="email"
            className="block text-[12px] font-medium text-[#555] mb-[5px]"
          >
            Email Address <span className="text-[#E05252]">*</span>
          </label>
          <input
            id="email"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email format",
              },
            })}
            placeholder="Enter your email"
            aria-describedby={errors.email ? "email-error" : undefined}
            className={`${INPUT_BASE} ${errors.email ? INPUT_ERR : INPUT_OK}`}
          />
          {errors.email && (
            <p id="email-error" role="alert" className="text-[#E05252] text-[11px] mt-1">
              {errors.email.message}
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          aria-busy={loading}
          className="w-full h-12 rounded-[10px] bg-gradient-to-r from-pink-500 to-purple-600 text-white text-[15px] font-bold relative border border-gray-300 hover:from-pink-600 hover:to-purple-700 hover:-translate-y-px transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <span className={loading ? "opacity-0" : "opacity-100"}>Send reset code →</span>
          {loading && (
            <ScaleLoader
              loading
              height={16}
              color="white"
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            />
          )}
        </button>

        <p className="mt-4 text-center text-[13px] text-gray-400">
          Remember it?{" "}
          <a href="/login" className="text-brand-purple font-semibold hover:underline">
            Back to login
          </a>
        </p>
      </form>
    </>
  );
};

export default ResetPassword;
